/**
 * Created with IntelliJ IDEA.
 * User: ShaharA
 * Date: 15/01/14
 * Time: 10:34 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");

    var DefaultPlusComponentItemModel = Backbone.Model.extend({
        defaults: {
            tooltip: "",   // language name to show on tooltip
            name: "",   // language 2 char code
            order: "",           // used internally to maintain sorting order
            activeTooltip: true
        }
    });

    return DefaultPlusComponentItemModel;
});